var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ajaxDone
    ? _c(
        "div",
        { ref: "latestDetailWrapper", staticClass: "newly-updated-daily" },
        [
          _c(
            "div",
            [
              _c("div", { staticClass: "daily-head" }, [
                _vm.LatestName
                  ? _c("h3", { staticClass: "daily-head-title" }, [
                      _vm._v(_vm._s(_vm.LatestName))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "analyse-info" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm._f("validCount")(_vm.LatestViewTotal)) +
                        "人浏览"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.LatestList, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "daily-content" },
                  [
                    _c("div", { staticClass: "daily-content-head" }, [
                      _vm._v(_vm._s(item.Depart))
                    ]),
                    _vm._v(" "),
                    _vm._l(item.List, function(v) {
                      return _c(
                        "div",
                        { staticClass: "daily-content-container" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "daily-content-card",
                              on: {
                                click: function($event) {
                                  return _vm.viewDetail(
                                    v.KBTypeId,
                                    v.KBInfoId,
                                    v
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "daily-tag-box" },
                                _vm._l(v.tagList, function(tag, i) {
                                  return _c("div", {
                                    staticClass: "daily-tag",
                                    class: {
                                      "daily-tag-edit": tag === "修改",
                                      "daily-tag-deleted": tag === "删除"
                                    },
                                    domProps: { textContent: _vm._s(tag) }
                                  })
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "daily-card-content" }, [
                                _vm._v(_vm._s(v.Title))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "daily-remark",
                            domProps: { innerHTML: _vm._s(v.Content) }
                          })
                        ]
                      )
                    })
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm.linkShow
                ? _c(
                    "div",
                    {
                      staticClass: "more-daily-text",
                      on: {
                        click: function($event) {
                          return _vm.$router.push({
                            path: "/recentDailyReport"
                          })
                        }
                      }
                    },
                    [_vm._v("更多近期知识日报")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.callUnauthorize
                ? _c("unauthorize", {
                    attrs: { unauthorizeType: _vm.unauthorizeType }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("water-mark", { ref: "watermark" })
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-6d29b85c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6d29b85c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/latestDetail.vue
// module id = null
// module chunks = 